// Export all page modules here
export { default as UCPList } from './UCPList';
export { default as Overview } from './Overview';
export { default as Activity } from './Activity';
export { default as Notes } from './Notes';
export { default as Snapshot } from './Snapshot';
export { default as Garage } from './Garage';
export { default as Appointments } from './Appointments';
export { default as RepairsOrders } from './RepairsOrders';
export { default as Tasks } from './Tasks';
export { default as TestEmail } from './TestEmail';

export const UCPPages = {
  UCPList: () => import('./UCPList'),
  Overview: () => import('./Overview'),
  Activity: () => import('./Activity'),
  Notes: () => import('./Notes'),
  Snapshot: () => import('./Snapshot'),
  Garage: () => import('./Garage'),
  Appointments: () => import('./Appointments'),
  RepairsOrders: () => import('./RepairsOrders'),
  Tasks: () => import('./Tasks'),
  TestEmail: () => import('./TestEmail')
}; 